import ajaxIcon from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ajaxLogoPortal.png';
import dahuaIcon from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dahuaLogoPortal.png';
import hikIcon from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hikLogoPortal.png';
import aiboxIcon from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/aiBoxLogoPortal.png';

export const INTEGRATION_ICON_MAP = {
    AJAX: ajaxIcon,
    DAHUA: dahuaIcon,
    HIKVISION: hikIcon,
    AIBOX: aiboxIcon,
};

export const getLinkedIntegrationIcon = (integrations, pin) => {
    const match = (integrations || []).find(integration => String(integration.pin) === String(pin));
    return match ? (INTEGRATION_ICON_MAP[match.integrationType] ?? null) : null;
};
